import type { BotConversationTurn } from './api/botApi'
import { AnswerCard } from './AnswerCard'

function formatAskedAt(iso: string): string {
  try {
    return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
  } catch {
    return ''
  }
}

interface TurnViewProps {
  turn: BotConversationTurn
}

/**
 * One turn: the user's question bubble + one AnswerCard per requested
 * model, stacked vertically. Side-by-side compare columns are P3 (see
 * Design Spec §9) — P2 always renders a single vertical stack.
 */
export function TurnView({ turn }: TurnViewProps) {
  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <div className="max-w-[85%] rounded-2xl rounded-br-md bg-primary text-on-primary px-4 py-2.5 text-sm whitespace-pre-wrap">
          <div>{turn.question}</div>
          <div className="mt-1 text-[10px] text-on-primary/70 text-right">{formatAskedAt(turn.askedAt)}</div>
        </div>
      </div>
      <div className="space-y-3">
        {turn.answers.map((answer) => (
          <AnswerCard key={answer.answerId} answer={answer} />
        ))}
      </div>
    </div>
  )
}
